<template>
  <div>
    <div class="container">
      <div
        class="modal fade right"
        id="modalComprovante"
        tabindex="-1"
        role="dialog"
        aria-labelledby="tituloComprovante"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="tituloComprovante">
                <i class="fas fa-vote-yea mr-1 pr-1"></i>
                Comprovante de Comparecimento
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div v-if="carregando" class="text-center">Carregando...</div>
              <div v-else-if="comprovante" class="area-comprovante">
                <div class="list-group-item indigo lighten-5 text-center">
                  <strong>{{ comprovante.strnome }}</strong> ({{ comprovante.strusuario }})
                  votou na eleição <strong>{{ comprovante.strdescricao }}</strong><br />
                  em <strong>{{ comprovante.dtavoto | dateFull_br }}</strong>.
                </div>
                <p class="note note-info mt-3" style="font-size:10pt">
                  Este comprovante atesta apenas o seu <strong>comparecimento</strong>. Para garantir o sigilo do voto,
                  o sistema não guarda nenhuma ligação entre você e o seu voto e, por isso, não é possível conferir
                  em quem você votou.
                </p>
              </div>
              <div v-else class="text-center">{{ mensagem }}</div>
            </div>
            <div class="modal-footer">
              <button v-if="comprovante" type="button" class="btn btn-primary" :disabled="enviando" @click="reenviar">
                <i class="fas fa-envelope mr-1"></i>
                {{ enviando ? 'Enviando...' : 'Reenviar por e-mail' }}
              </button>
              <button type="button" data-dismiss="modal" class="btn btn-danger">Fechar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Mixin from "./../../mixins";
export default {
  mixins: [Mixin],
  props: ["eleicao"],
  data() {
    return {
      carregando: true,
      enviando: false,
      comprovante: null,
      mensagem: ""
    };
  },
  methods: {
    carregar() {
      this.carregando = true;
      axios.post("/votos/comprovante", { inteleicaoid: this.eleicao.id })
        .then(res => {
          this.comprovante = res.data.comprovante;
        }, err => {
          this.mensagem = (err.response && err.response.data && err.response.data.mensagem) || "Comprovante não encontrado";
        })
        .then(() => { this.carregando = false; });
    },
    reenviar() {
      this.enviando = true;
      axios.post("/votos/comprovante/enviar", { inteleicaoid: this.eleicao.id })
        .then(res => {
          toastr.success(res.data.mensagem);
        }, err => {
          toastr.error((err.response && err.response.data && err.response.data.mensagem) || "Falha ao enviar o comprovante");
        })
        .then(() => { this.enviando = false; });
    }
  },
  mounted() {
    this.carregar();
  }
};
</script>
<style>
.area-comprovante {
  width: 100% !important;
}
</style>
